






















import { Component, Vue, Prop } from 'vue-property-decorator'
import { Track } from '../classes/track'
import Axios from 'axios'

@Component({})
export default class PlaylistSaveModal extends Vue {
  @Prop({
    default: ''
  })
  playlistName: string

  @Prop({
    default: () => []
  })
  tracks: Track[]

  @Prop()
  disabled: boolean

  loading: boolean = false
  modalOpen: boolean = false
  playlistNameModel: string = this.playlistName

  open(e: MouseEvent) {
    const path = (e as any)?.path

    if (path) {
      const btn = path[1]

      if (btn?.tagName === 'BUTTON' && btn.disabled) return
    }

    if (this.disabled) return

    this.playlistNameModel = this.playlistName

    this.modalOpen = true
  }

  close() {
    this.modalOpen = false
  }

  async save() {
    if (this.loading || this.disabled) return

    this.loading = true

    try {
      const { data } = await Axios.post('/playlist/create', {
        name: this.playlistNameModel,
        trackIds: this.tracks.map(x => x._id)
      })

      if (data.playlists) {
        this.$store.commit('library/replacePlaylists', data)
      }

      this.$buefy.notification.open('Saved to playlist: ' + this.playlistNameModel)

      this.$emit('save')
    } catch (error) {
      console.error(error)

      if (this.$store.state.auth.isDemoUser) {
        this.$buefy.notification.open(`Saved to playlist: ${this.playlistNameModel}`)
      }
    }

    this.loading = false

    this.close()
  }
}
